import { agencyIdFromPath } from './agencyAccess';
import { useShigoSession } from '../../lib/useShigoSession';
import {
  publisherIdFromPath,
  resolveOwnedDashboardContext,
  ShigoDashboardContext,
} from './dashboardDestination';

export function useShigoDashboardContext(pathname: string): ShigoDashboardContext | null {
  const { session } = useShigoSession();
  if (agencyIdFromPath(pathname) !== null) return ShigoDashboardContext.Agency;
  if (publisherIdFromPath(pathname) !== null) return ShigoDashboardContext.Publisher;
  return session ? resolveOwnedDashboardContext(session.user) : null;
}
